module.exports = __webpack_public_path__ + "static/media/LK.d5cf9401.svg";